import appConfig from '@/config/env';
import { ROOT_FOLDER } from '@/consts';

/** MVP heuristic (SPX ticket, Elbit): any item whose parent isn't root is treated as
 *  living inside a workspace, so policy changes are disabled. This will also
 *  match non-workspace nested folders — acceptable per the ticket. Gated by
 *  DISABLE_POLICY_CHANGE_FOR_NESTED_ITEMS so only opted-in tenants are affected. */
const isNestedItem = (file?: { parent_folder?: string }): boolean => (
    !!appConfig.DISABLE_POLICY_CHANGE_FOR_NESTED_ITEMS
    && !!file?.parent_folder
    && file.parent_folder !== ROOT_FOLDER
);

export default isNestedItem;
